import API from "@aws-amplify/api";
import { createArenaBattle, updateArenaBattle } from "../../graphql/mutations";
import { getArenaBattle, arenaBattlesByWorkspace } from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createBattle_ = async (object, authToken) => {
  return makeGraphQLRequest({
    query: createArenaBattle,
    variables: { input: object },
  });
};
const getBattle_ = async (id) => {
  return makeGraphQLRequest({
    query: getArenaBattle,
    variables: { id },
  });
};

const getBattlesByWorkspace = async (workspaceId) => {
  return makeGraphQLRequest({
    query: arenaBattlesByWorkspace,
    variables: { workspaceID: workspaceId },
  });
};

const updateBattle = async (id, args, authToken) => {
  const original = await getBattle_(id);
  let _properties = {};
  args.forEach((item) => {
    _properties[item.property] = item.value;
  });
  return makeGraphQLRequest({
    query: updateArenaBattle,
    variables: {
      input: {
        id,
        _version: original?.data?.getArenaBattle?._version,
        ..._properties,
      },
    },
  });
};

export default {
  createBattle_,
  getBattle_,
  updateBattle,
  getBattlesByWorkspace,
};
